export default "__VITE_ASSET__AmE1c5sH__"